import * as AdobeIO from './adobe'
import * as FileIO from './file'
import * as HttpIO from './http'
import * as PlayerIO from './player'
import * as StrIO from './str'

export type IO = typeof io

export const io = <const>{
  ...AdobeIO,
  ...FileIO,
  httpPutUri: HttpIO.put,
  httpGetJson: HttpIO.getJSON,
  httpPostJson: HttpIO.postJSON,
  ...PlayerIO,
  ...StrIO,
}
